import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router";
import {
  SlButton,
  SlDrawer,
  SlOption,
  SlSelect,
  SlInput,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import { ScrollContainer } from "react-indiana-drag-scroll";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import Paginator from "../../shared/Paginator";
import { debounce } from "../../utils/Debounce";
import config from "../../config";
import { roles } from "../../utils/constants";
import { toast } from "react-toastify";

export const campCreativeContext = React.createContext();

function AdsPrices() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [show, setShow] = useState(false);

  const [languages, setLanguages] = useState([]);
  const [languageSelected, setLanguageSelected] = useState(1);
  const [districts, setDistricts] = useState([]);
  const [districtSelected, setDistrictSelected] = useState("0");
  const [custId, setCustId] = useState("");
  const [ugcUserdetails, setUgcUserDetails] = useState({});
  const [agentName, setAgentName] = useState("");
  const [data, setData] = useState([]);
  const [agentAds, setAgentAds] = useState([]);
  const [ugcUsers, setUgcUsers] = useState([]);
  const [langId, setLangId] = useState(1);
  const [distId, setDistId] = useState("0");
  const [mandalId, setMandalId] = useState(0);
  const [paymentmethod, setPaymentMethod] = useState("");
  const [preview, setPreview] = useState(false);
  const [view, setView] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pages, setPages] = useState(0);
  const [presentPage, setPresentPage] = useState(0);
  const [search, setSearch] = useState("");

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };
  const handlePages = async (event) => {
    setPresentPage(event.selected);
  };

  const [selectedRecords, setSelectedRecords] = useState([]);

  useEffect(() => {
    setSelectedRecords(
      ugcUsers
        .filter((item) => item.is_ad_agent === 1)
        .map((item) => item.custid)
    );
  }, [ugcUsers]);

  const toggleCheckbox = async (recordId, userName, isAdAgent) => {
    if (selectedRecords.includes(recordId)) {
      setSelectedRecords(
        selectedRecords.filter((custid) => custid !== recordId)
      );
      setView(false);
      setUgcUserDetails({
        user_name: userName,
        is_ad_agent: 0,
        cust_id: recordId,
      });
      try {
        let res = await api({
          url: `/agent_adv_details/updateUserAgent`,
          method: "POST",
          responseType: "json",
          data: {
            ugcUserdetails: {
              user_name: userName,
              is_ad_agent: 0,
              cust_id: recordId,
            },
          },
        });
        if (res?.data?.code === 500) {
          Toast("error", res.data.message);
        } else {
          Toast("success", "User ad agent removed Successfully");
          setView(false);
          setPaymentMethod("");

          reset(initialDetails);
          getUgcUsers(langId, distId, search, 0);
          // setSearch('');
          // loadData(search, 0);
        }
      } catch (error) {
        let er = error?.response?.message || "Something went wrong";
        Toast("error", er);
        if (error.response.status === 401) navigate("/");
      }
    } else {
      setSelectedRecords([...selectedRecords, recordId]);
      setView(true);
      setUgcUserDetails({
        user_name: userName,
        is_ad_agent: 1,
        cust_id: recordId,
      });
    }
  };
  //     if (isAdAgent === 1) {
  //         setView(false);
  //         setUgcUserDetails({ user_name: userName, is_ad_agent: 0, cust_id: recordId });
  //         setSelectedRecords(selectedRecords.filter((custid) => custid !== recordId));
  //         toast.success("User removed from Ad Agent");

  //     } else {
  //         setView(true);
  //         setUgcUserDetails({ user_name: userName, is_ad_agent: 1, cust_id: recordId });
  //         setSelectedRecords([...selectedRecords, recordId]);
  //     }
  // };

  const getLanguages = async () => {
    if (localStorage.getItem("role") === roles.ops) {
      setLoader(true);
      const response = await api({
        url: `/ads_price_location/getLanguages`,
        method: "POST",
        responseType: "json",
      });
      setLanguages(response.data.data);
      setLoader(false);
    }
  };
  const getDistricts = async (languageSelected) => {
    if (localStorage.getItem("role") === roles.ops) {
      setLoader(true);
      const response = await api({
        url: `/ads_price_location/getDistricts`,
        method: "POST",
        responseType: "json",
        data: {
          lang_id: parseInt(languageSelected),
        },
      });
      setDistricts(response.data.data);
      setLoader(false);
    }
  };

  const getAdsAgents = async (languageSelected, districtSelected, page = 0) => {
    if (localStorage.getItem("role") === roles.ops) {
      setLoader(true);
      const response = await api({
        url: `/agent_adv_details/getAdsAgent`,
        method: "POST",
        responseType: "json",
        data: {
          lang_id: parseInt(languageSelected),
          dist_id: parseInt(districtSelected),
          page,
          limit: config.PER_PAGE,
        },
      });
      setData(response.data.data);
      setTotalPages(Math.ceil(response.data.totalCount / config.PER_PAGE));
      setLoader(false);
    }
  };

  const getAgentAds = async (custId) => {
    if (localStorage.getItem("role") === roles.ops) {
      setLoader(true);
      const response = await api({
        url: `/agent_adv_details/getAgentAds`,
        method: "POST",
        responseType: "json",
        data: {
          cust_id: parseInt(custId),
        },
      });
      setAgentAds(response.data.data);
      setLoader(false);
    }
  };

  const getUgcUsers = async (langId, distId, search, page = 0) => {
    if (localStorage.getItem("role") === roles.ops) {
      setLoader(true);
      const response = await api({
        url: `/agent_adv_details/getUgcUsers`,
        method: "POST",
        responseType: "json",
        data: {
          lang_id: parseInt(langId),
          dist_id: parseInt(distId),
          user_name: search,
          page,
          limit: config.PER_PAGE,
        },
      });
      setUgcUsers(response.data.data);
      setPages(Math.ceil(response.data.totalCount / config.PER_PAGE));
      setLoader(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("role") === roles.ops) {
      getLanguages();
      getDistricts(1);
    }
  }, []);

  // useEffect(() => {
  //     if (localStorage.getItem("role") === roles.ops) {
  //         getDistricts(1);
  //     }
  // }, [])

  useEffect(() => {
    if (localStorage.getItem("role") === roles.ops) {
      getAdsAgents(languageSelected, districtSelected, currentPage);
    }
  }, [languageSelected, districtSelected, currentPage]);

  useEffect(() => {
    if (localStorage.getItem("role") === roles.ops) {
      getUgcUsers(langId, distId, search, presentPage);
    }
  }, [langId, distId, search, presentPage]);

  const changeLanguageHandler = (event) => {
    setLanguageSelected(event.target.value);
    getDistricts(event.target.value);
    setDistrictSelected("0");
  };

  const changeDistrictHandler = (event) => {
    setDistrictSelected(event.target.value);
  };

  const distoptions = [
    { value: "0", label: "All" },
    ...districts.map((item) => ({
      value: item.dist_id,
      label: item.dist_name,
    })),
  ];
  const paymentMethods = [
    { value: "paytm", label: "Paytm" },
    { value: "bank", label: "Bank" },
    { value: "upi", label: "UPI" },
  ];

  const langoptions = languages.map((item) => ({
    value: item.lang_id,
    label: item.lang_name,
  }));

  const changeUgcLanguageHandler = (selectedOption) => {
    setLangId(selectedOption.value);
    getDistricts(selectedOption.value);
    setDistId("0");
  };

  const changeUgcDistrictHandler = (selectedoption) => {
    setDistId(selectedoption.value);
  };

  const changePaymentHandler = (selectedOption) => {
    setPaymentMethod(selectedOption.value);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedRecords([]);
  };
  const handlePaymentClose = () => {
    setView(false);
    setSubmit(false);
  };

  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }

  const searchData = (e) => {
    setSearch(e.target.value);
    setCurrentPage(0);
  };

  function formatDateToReadable(timestamp) {
    const date = new Date(timestamp * 1000);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${day}-${month}-${year} ${formattedHours}:${formattedMinutes} ${ampm}`;
  }

  const initialDetails = {
    mobile_number: "",
    bank_name: "",
    account_number: "",
    ifsc: "",
    address: "",
    upi: "",
    paymentmethod: "",
  };

  const onSubmit = async (data) => {
    try {
      let res = await api({
        url: `/agent_adv_details/updateUserAgent`,
        method: "POST",
        responseType: "json",
        data: { data, ugcUserdetails },
      });
      if (res?.data?.code === 500) {
        Toast("error", res.data.message);
      } else {
        Toast("success", "Payment Details Added Successfully");
        setView(false);
        // resetField(paymentmethod);
        setPaymentMethod("");

        reset(initialDetails);
        getUgcUsers(langId, distId, search, 0);
        // setSearch('');
        // loadData(search, 0);
      }
    } catch (error) {
      let er = error?.response?.message || "Something went wrong";
      Toast("error", er);
      if (error.response.status === 401) navigate("/");
    }
  };

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    resetField,
    control,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });

  return (
    <>
      <div className="card-body cc-body">
        <div className="">
          <div className="flex items-center gap-3 mb-3">
            {/* <aside className="flex items-center gap-3 ml-auto"> */}
            <div>
              <SlSelect
                size="medium"
                placeholder="Select Language"
                onSlChange={changeLanguageHandler}
                value={languageSelected}
              >
                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                {languages.map((item) => (
                  <SlOption key={item.lang_id} value={item.lang_id}>
                    {item.lang_name}
                  </SlOption>
                ))}
              </SlSelect>
            </div>

            <div>
              <SlSelect
                size="medium"
                placeholder="Select District"
                onSlChange={changeDistrictHandler}
                value={districtSelected}
              >
                <SlIcon library="lucide" name="eye" slot="prefix"></SlIcon>
                <SlOption key={0} value="0">
                  {"All"}
                </SlOption>
                {districts.map((item) => (
                  <SlOption key={item.dist_id} value={item.dist_id}>
                    {item.dist_name}
                  </SlOption>
                ))}
              </SlSelect>
            </div>
            <div>
              <SlButton
                size="small"
                variant="primary"
                onClick={async () => {
                  setShow(true);
                  await getUgcUsers(langId, distId, "", 0);
                }}
              >
                Add new Agent
              </SlButton>
            </div>
            {/* </aside > */}
          </div>

          <div className=" mb-4">
            <ScrollContainer>
              <table className="table table-bordered">
                <thead className="sticky top-0 ">
                  <tr>
                    <th>Dealer Name</th>
                    <th>Mobile No</th>
                    <th>District</th>
                    <th>Number of Ads</th>
                    <th>Ad Amount</th>
                    <th>Ad Commission</th>
                    <th>View Ads</th>
                  </tr>
                </thead>
                {data?.length && !loader ? (
                  <tbody>
                    {data.map((item) => {
                      return (
                        <tr
                          key={item.custid}
                          className="group/details hover:bg-slate-100"
                        >
                          <th scope="row">{item.user_name}</th>
                          <td>{item.mobile_no}</td>
                          <td>{item.dist_name || "-"}</td>
                          <td>{item.totalPosts || "-"}</td>
                          <td>{item.adAmount === null ? 0 : item.adAmount}</td>
                          <td>
                            {item.adAmount ? (item.adAmount * 15) / 100 : 0}
                          </td>
                          <td>
                            {localStorage.getItem("role") === roles.ops ? (
                              <sl-tooltip content="View Ads">
                                <sl-icon-button
                                  library="lucide"
                                  name="eye"
                                  onClick={async () => {
                                    setCustId(item.custid);
                                    setAgentName(item.user_name);
                                    await getAgentAds(item.custid);
                                    setPreview(true);
                                  }}
                                ></sl-icon-button>
                              </sl-tooltip>
                            ) : null}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                ) : !data?.length && !loader ? (
                  <NoDataFound colspan="8" />
                ) : (
                  <TableLoader colspan="8" />
                )}
              </table>
            </ScrollContainer>
          </div>
          <div className="flex justify-end">
            {totalPages > 1 && (
              <Paginator
                pageCount={totalPages}
                handlePageClick={handlePageClick}
                forcePage={currentPage}
              />
            )}
          </div>
          <SlDrawer
            label={`Ads of ${agentName}`}
            open={preview}
            onSlRequestClose={handleRequestClose}
            onSlAfterHide={() => {
              setPreview(false);
            }}
            style={{ "--size": "70vw" }}
          >
            <div className="overflow-x-auto">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Post Title</th>
                    <th>Post Status</th>
                    <th>Post Date</th>
                    <th>Location</th>
                    <th>Priority</th>
                    <th>Ad Amount</th>
                    <th>Ad Date(s)</th>
                  </tr>
                </thead>
                {agentAds?.length && !loader ? (
                  <tbody>
                    {agentAds.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item.post_title || "-"}</td>
                          {item.post_status === "submit" ? (
                            <td>{"Under Review"}</td>
                          ) : item.post_status === "submittolocal" ? (
                            <td>{"Published"}</td>
                          ) : item.post_status === "finished" ? (
                            <td>{"Finished"}</td>
                          ) : item.post_status === "feedback" ? (
                            <td>{"Rejected"}</td>
                          ) : (
                            <td>{"Initiated"}</td>
                          )}
                          <td>{formatDateToReadable(item.post_gmt) || "-"}</td>
                          <td>
                            {item.ad_location ? item.ad_location : "mandal"}
                          </td>
                          <td>
                            {item.ad_premium ? item.ad_premium : "normal"}
                          </td>
                          <td>{item.adAmount ? parseInt(item.adAmount) : 0}</td>
                          <td>
                            {item.adsDates
                              ? item.adsDates.split(",").join(", ")
                              : ""}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                ) : !agentAds?.length && !loader ? (
                  <NoDataFound colspan="8" />
                ) : (
                  <TableLoader colspan="8" />
                )}
              </table>
            </div>
          </SlDrawer>
        </div>
      </div>
      <div>
        <SlDrawer
          label={`Add new Agent`}
          open={show}
          onSlRequestClose={handleRequestClose}
          onSlAfterHide={handleClose}
          style={{ "--size": "70vw" }}
        >
          <div className="overflow-x-auto">
            <div className="flex items-center mb-3">
              <div>
                {/* <SlSelect
                                    size="medium"
                                    placeholder="Select Language"
                                    onSlChange={changeUgcLanguageHandler}
                                    value={langId}
                                >
                                    <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                                    {languages.map(item => (
                                        <SlOption key={item.lang_id} value={item.lang_id}>
                                            {item.lang_name}
                                        </SlOption>
                                    ))}

                                </SlSelect> */}
                <Select
                  options={langoptions}
                  placeholder="Select Language"
                  onChange={changeUgcLanguageHandler}
                  value={langoptions.find((option) => option.value === langId)}
                  styles={{
                    marginRight: 8,
                    height: 10,
                    minWidth: 1000,
                  }}
                />
              </div>
              <div>
                {/* <SlSelect
                                    size="medium"
                                    placeholder="Select District"
                                    onSlChange={changeUgcDistrictHandler}
                                    value={distId}
                                >
                                    <SlIcon library="lucide" name="eye" slot="prefix"></SlIcon>
                                    <SlOption key={0} value="0">
                                        {"All"}
                                    </SlOption>
                                    {districts.map(item => (
                                        <SlOption key={item.dist_id} value={item.dist_id}>
                                            {item.dist_name}
                                        </SlOption>
                                    ))}

                                </SlSelect> */}
                <Select
                  options={distoptions}
                  placeholder="Select District"
                  onChange={changeUgcDistrictHandler}
                  value={distoptions.find((option) => option.value === distId)}
                  styles={{
                    marginRight: 8,
                    height: 10,
                    minWidth: 1000,
                  }}
                />
              </div>

              <div>
                <SlInput
                  size="medium"
                  id="myInput"
                  onSlInput={debounce(searchData, 500)}
                  placeholder="Search by UserName or Mobile"
                >
                  <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                </SlInput>
              </div>
            </div>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>User Name</th>
                  <th>Mobile Number</th>
                  <th>User Level</th>
                  <th>Is Verified</th>
                  <th>Agent Status</th>
                </tr>
              </thead>
              {ugcUsers?.length && !loader ? (
                <tbody>
                  {ugcUsers.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{item.user_name || "-"(item.topic_name)}</td>
                        <td>{item.mobile_no || "-"}</td>
                        <td>{item.user_level || "-"}</td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {item.is_verified === 1 ? (
                            <span style={{ color: "green" }}>
                              <SlIcon
                                library="lucide"
                                name="check-circle"
                                className="mr-1"
                                style={{ "--size": "15rem" }}
                              ></SlIcon>
                            </span>
                          ) : (
                            <span style={{ color: "red" }}>
                              <SlIcon
                                library="lucide"
                                name="x-circle"
                                className="mr-1"
                                style={{ "--size": "15rem" }}
                              ></SlIcon>
                            </span>
                          )}
                        </td>
                        {/* <td>{item.is_ad_agent}</td> */}

                        {/* {(item.is_ad_agent === 0) ? (<td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedRecords.includes(item.custid)}
                                                        onChange={() => toggleCheckbox(item.custid, item.user_name, item.is_ad_agent)}
                                                    />
                                                </td>) : <td><input type="checkbox"
                                                    checked={true}
                                                    onChange={() => toggleCheckbox(item.custid, item.user_name, item.is_ad_agent)}
                                                /></td>} */}

                        {
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedRecords.includes(item.custid)}
                              onChange={() =>
                                toggleCheckbox(
                                  item.custid,
                                  item.user_name,
                                  item.is_ad_agent
                                )
                              }
                            />
                          </td>
                        }
                      </tr>
                    );
                  })}
                </tbody>
              ) : !ugcUsers?.length && !loader ? (
                <NoDataFound colspan="8" />
              ) : (
                <TableLoader colspan="8" />
              )}
            </table>
          </div>
          <div className="flex justify-end">
            {pages > 1 && (
              <Paginator
                pageCount={pages}
                handlePageClick={handlePages}
                forcePage={presentPage}
              />
            )}
          </div>
        </SlDrawer>
      </div>

      <SlDrawer
        label="Add agent Payment Details"
        open={view}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={handlePaymentClose}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <label className="form-label">Payment Method</label>
            <Controller
              name="paymentmethod" // Name of the form field
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Select
                  {...field}
                  defaultValue={paymentmethod}
                  name="paymentmethod"
                  options={paymentMethods}
                  classNamePrefix="select"
                  onChange={(selectedOption) => {
                    field.onChange(selectedOption);
                    changePaymentHandler(selectedOption); // Call your custom handler
                  }}
                />
              )}
            />
            {errors?.paymentmethod ? (
              <span className="red-text">Payment Method is required</span>
            ) : null}
          </div>

          {paymentmethod === "paytm" && (
            <div className="mb-3">
              <label className="mb-1"> Mobile Number</label>
              <span className="text-red-600">*</span>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Mobile Number"
                aria-label=""
                name="mobile_number"
                {...register("mobile_number", {
                  required: true,
                })}
              />
              {errors.mobile_number ? (
                <div className="text-red-600 ">Mobile Number is required</div>
              ) : null}
            </div>
          )}
          {paymentmethod === "bank" && (
            <div className="mb-3">
              <label className="mb-1"> Bank Name</label>
              <span className="text-red-600">*</span>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Bank Name"
                aria-label=""
                name="bank_name"
                {...register("bank_name", {
                  required: true,
                })}
              />
              {errors.bank_name ? (
                <div className="text-red-600 ">Bank Name is required</div>
              ) : null}
            </div>
          )}

          {paymentmethod === "bank" && (
            <div className="mb-3">
              <label className="mb-1"> Account Number</label>
              <span className="text-red-600">*</span>
              <input
                type="number"
                className="form-control"
                placeholder="Enter Account Number"
                aria-label=""
                name="account_number"
                {...register("account_number", {
                  required: true,
                })}
              />
              {errors.account_number ? (
                <div className="text-red-600 ">Account Number is required</div>
              ) : null}
            </div>
          )}

          {paymentmethod === "bank" && (
            <div className="mb-3">
              <label className="mb-1">IFSC Code</label>
              <span className="text-red-600">*</span>
              <input
                type="text"
                className="form-control"
                placeholder="Enter IFSC Code"
                aria-label=""
                name="ifsc"
                {...register("ifsc", {
                  required: true,
                })}
              />
              {errors.ifsc ? (
                <div className="text-red-600 ">IFSC Code is required</div>
              ) : null}
            </div>
          )}

          {paymentmethod === "bank" && (
            <div className="mb-3">
              <label className="mb-1"> Address </label>
              <span className="text-red-600">*</span>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Address"
                aria-label=""
                name="address"
                {...register("address", {
                  required: true,
                })}
              />
              {errors.address ? (
                <div className="text-red-600 ">Address is required</div>
              ) : null}
            </div>
          )}

          {paymentmethod === "upi" && (
            <div className="mb-3">
              <label className="mb-1"> UPI </label>
              <span className="text-red-600">*</span>
              <input
                type="text"
                className="form-control"
                placeholder="Enter UPI / Mobile"
                aria-label=""
                name="upi"
                {...register("upi", {
                  required: true,
                })}
              />
              {errors.upi ? (
                <div className="text-red-600 ">UPI is required</div>
              ) : null}
            </div>
          )}

          <SlButton
            type="submit"
            variant="primary"
            size="small"
            // onClick={() => { setSubmit(true) }}
          >
            Submit
          </SlButton>
        </form>
      </SlDrawer>
    </>
  );
}

export default AdsPrices;
